import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppConfig } from '../../bootstrap/app.config';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CaptchaService {

  constructor(private httpClient: HttpClient, private config: AppConfig) { }

  createChallengeJson(): Observable<any> {
    return this.httpClient.get(this.config.getLoginHostURL() + "Captcha/challenge", { responseType: 'json' }).pipe(
      catchError((error) => {
        console.error('Error fetching challenge JSON:', error.message, error);
        return throwError(() => new Error('Failed to fetch challenge JSON'));
      })
    );
  }

  getSerializedAltchaStrings(): Observable<any> {
    return this.httpClient.get(this.config.getLoginHostURL() + "Captcha/strings", { responseType: 'json' }).pipe(
      catchError((error) => {
        console.error('Error fetching serialized strings:', error.message, error);
        return throwError(() => new Error('Failed to fetch serialized strings'));
      })
    );
  }
}
